export const getReferralCodeFromCustomerNumber = (accountNumber) => {
  const reversedNumber = [...accountNumber].reverse()
  const referralCode = reversedNumber
    .map((char) => {
      const charCode = char.charCodeAt(0) + 24
      const isAllowedCharacter = charCode >= 65 && charCode <= 90
      return isAllowedCharacter && String.fromCharCode(charCode)
    })
    .filter((char) => !!char)
    .join("")

  return "S" + referralCode
}

export const customerNumberFromReferralCode = (referralCode) => {
  return [...referralCode.slice(1)]
    .reverse()
    .map((it) => {
      if (it.match(/[a-zA-Z]/)) {
        return String.fromCharCode(it.charCodeAt(0) - 24)
      }
      return null
    })
    .filter((it) => it !== null)
    .join("")
}
